/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function TitleField (props: FormTextFieldProps) {
  const { name = 'title', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'title',
        defaultMessage: 'Titre'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default TitleField
